var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "tab-pane fade",
    class: {
      'show active': _vm.isActive
    },
    attrs: {
      "id": "nav-vault-rewards",
      "role": "tabpanel",
      "aria-labelledby": "nav-vault-rewards-tab3",
      "tabindex": "1"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [!_vm.isActive ? _c('div') : _vm.loading ? _c('div', {
    staticClass: "vault-state-panel vault-state-panel--loading",
    attrs: {
      "role": "status",
      "aria-live": "polite"
    }
  }, [_c('div', {
    staticClass: "vault-state-spinner",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('p', {
    staticClass: "vault-state-title"
  }, [_vm._v("Loading vault rewards")]), _c('p', {
    staticClass: "vault-state-hint"
  }, [_vm._v("Please wait…")])]) : _vm.error ? _c('div', {
    staticClass: "vault-state-panel vault-state-panel--error",
    attrs: {
      "role": "alert"
    }
  }, [_vm._m(0), _c('p', {
    staticClass: "vault-state-title"
  }, [_vm._v("Unable to load rewards")]), _c('p', {
    staticClass: "vault-state-message"
  }, [_vm._v(_vm._s(_vm.error))])]) : _vm.isEmpty ? _c('div', {
    staticClass: "vault-state-panel vault-state-panel--empty"
  }, [_vm._m(1), _c('p', {
    staticClass: "vault-state-title"
  }, [_vm._v("No vault rewards yet")]), _c('p', {
    staticClass: "vault-state-hint"
  }, [_vm._v("Rewards you earn will appear here when available.")])]) : _c('div', [_c('div', {
    staticClass: "vault"
  }, [_c('div', {
    staticClass: "vault-header"
  }, [_c('div', {
    staticClass: "flex flex-row items-center justify-between"
  }, [_c('div', {
    staticClass: "flex flex-row items-center gap-4"
  }, [_c('div', {
    staticClass: "vault-icon flex items-center justify-center"
  }, [_c('svg', {
    attrs: {
      "width": "40",
      "height": "40",
      "viewBox": "0 0 40 40",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M19.2704 5.44334C19.3423 5.31268 19.448 5.20373 19.5764 5.12785C19.7048 5.05196 19.8512 5.01193 20.0004 5.01193C20.1495 5.01193 20.296 5.05196 20.4244 5.12785C20.5528 5.20373 20.6584 5.31268 20.7304 5.44334L25.6504 14.7833C25.7677 14.9996 25.9315 15.1872 26.1299 15.3327C26.3283 15.4782 26.5565 15.5779 26.798 15.6248C27.0396 15.6716 27.2885 15.6644 27.5269 15.6036C27.7654 15.5429 27.9874 15.4301 28.177 15.2733L35.3054 9.16667C35.4422 9.05538 35.6108 8.99037 35.787 8.98101C35.9631 8.97165 36.1377 9.01842 36.2855 9.11458C36.4334 9.21075 36.5469 9.35136 36.6098 9.51616C36.6727 9.68096 36.6816 9.86146 36.6354 10.0317L31.912 27.1083C31.8156 27.4578 31.6079 27.7663 31.3204 27.987C31.0329 28.2078 30.6812 28.3288 30.3187 28.3317H9.68371C9.32094 28.3291 8.9689 28.2083 8.68103 27.9875C8.39317 27.7667 8.18521 27.4581 8.08872 27.1083L3.36705 10.0333C3.3208 9.86313 3.32975 9.68263 3.39262 9.51782C3.45548 9.35302 3.56902 9.21242 3.71688 9.11625C3.86475 9.02008 4.03931 8.97331 4.21545 8.98267C4.39159 8.99203 4.56021 9.05704 4.69705 9.16834L11.8237 15.275C12.0134 15.4317 12.2354 15.5445 12.4738 15.6053C12.7122 15.6661 12.9612 15.6733 13.2027 15.6264C13.4443 15.5796 13.6724 15.4799 13.8709 15.3344C14.0693 15.1889 14.2331 15.0013 14.3504 14.785L19.2704 5.44334Z",
      "stroke": "#0F172B",
      "stroke-width": "3.33333",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M8.33398 35H31.6673",
      "stroke": "#0F172B",
      "stroke-width": "3.33333",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]), _c('div', {
    staticClass: "vault-title flex flex-col gap-4"
  }, [_c('h3', {
    staticClass: "vault-name m-0"
  }, [_vm._v(_vm._s(_vm.selectedVaultTitle))]), _c('div', {
    staticClass: "flex flex-row items-center gap-4"
  }, [_vm.selectedVaultStart ? _c('div', {
    staticClass: "badge"
  }, [_c('i', {
    staticClass: "far fa-calendar"
  }), _c('span', {
    staticClass: "badge-label"
  }, [_vm._v("Start Date:")]), _c('span', [_vm._v(_vm._s(_vm.selectedVaultStart))])]) : _vm._e(), _vm.selectedVaultEnd ? _c('div', {
    staticClass: "badge"
  }, [_c('i', {
    staticClass: "far fa-clock"
  }), _c('span', {
    staticClass: "badge-label"
  }, [_vm._v("End Date:")]), _c('span', [_vm._v(_vm._s(_vm.selectedVaultEnd))])]) : _vm._e()])])]), _vm.vaults.length >= 1 ? _c('div', {
    staticClass: "vault-select-wrap"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.selectedVaultId,
      expression: "selectedVaultId"
    }],
    staticClass: "vault-select",
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.selectedVaultId = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }
    }
  }, _vm._l(_vm.vaults, function (v) {
    return _c('option', {
      key: String(v.vault_id),
      domProps: {
        "value": String(v.vault_id)
      }
    }, [_vm._v(" " + _vm._s(_vm.vaultOptionLabel(v)) + " ")]);
  }), 0)]) : _vm._e()])]), _c('div', {
    staticClass: "vault-body"
  }, [_c('div', {
    staticClass: "vault-rewards"
  }, [!_vm.selectedRewards.length ? _c('div', {
    staticClass: "reward-item"
  }, [_vm._m(2), _vm._m(3)]) : _vm._l(_vm.decoratedRewards, function (row) {
    return _c('div', {
      key: row.rowKey,
      staticClass: "reward-item"
    }, [_c('div', {
      staticClass: "reward-ribben",
      class: row.rarityClass
    }, [_c('span', [_vm._v(_vm._s(row.rarityLabel))])]), _c('div', {
      staticClass: "flex flex-col gap-4 h-100"
    }, [_c('div', {
      staticClass: "reward-thumbnail"
    }, [row.imageSrc ? _c('img', {
      attrs: {
        "src": row.imageSrc,
        "alt": row.imageAlt
      }
    }) : _c('span', {
      staticClass: "reward-thumb-text"
    }, [_vm._v(" " + _vm._s(row.typeLabel) + " ")])]), _c('div', {
      staticClass: "reward-name"
    }, [_c('span', [_vm._v(_vm._s(row.title))])]), _c('div', {
      staticClass: "reward-status",
      class: ("reward-status--" + (row.statusKey))
    }, [row.statusKey === 'claimed' || row.reward.claimed_at ? _c('span', [_vm._v(" Claimed. " + _vm._s(_vm.formatDate(row.reward.claimed_at)) + " ")]) : row.reward.expire_at ? _c('span', [_vm._v(" Exp. " + _vm._s(_vm.formatDate(row.reward.expire_at)) + " ")]) : _c('span', [_vm._v(" Status not available ")])]), _c('div', {
      staticClass: "reward-action"
    }, [row.showClaimed ? _c('div', {
      staticClass: "reward-claimed"
    }, [_vm._m(4, true)]) : row.typeKey === 'digital' ? _c('button', {
      staticClass: "reward-cta",
      class: {
        'reward-cta--disabled': row.statusKey === 'expired'
      },
      attrs: {
        "type": "button",
        "disabled": _vm.digitalClaimLoading || row.statusKey === 'expired'
      },
      on: {
        "click": function ($event) {
          return _vm.openDigitalClaim(row.reward);
        }
      }
    }, [_vm._v(" " + _vm._s(row.statusKey === 'expired' ? 'Expired' : 'Redeem') + " ")]) : _c('a', {
      staticClass: "reward-cta",
      class: {
        'reward-cta--disabled': row.storeRedeemDisabled
      },
      attrs: {
        "href": !row.storeRedeemDisabled ? _vm.redeemUrl(row.reward.coupon_code) : null,
        "target": "_blank",
        "rel": "noopener noreferrer",
        "aria-disabled": String(row.storeRedeemDisabled)
      },
      on: {
        "click": function ($event) {
          row.storeRedeemDisabled && $event.preventDefault();
        }
      }
    }, [_vm._v(" " + _vm._s(row.statusKey === 'expired' ? 'Expired' : row.statusKey === 'claimed' ? 'Claimed' : 'Redeem') + " ")])])])]);
  })], 2)])])])])]), _vm.digitalClaimOpen ? _c('div', {
    staticClass: "vault-modal-backdrop"
  }, [_c('div', {
    staticClass: "vault-modal"
  }, [_c('h4', {
    staticClass: "vault-modal-title"
  }, [_vm._v("Claim digital reward")]), _vm.digitalClaimError ? _c('p', {
    staticClass: "vault-modal-error"
  }, [_vm._v(_vm._s(_vm.digitalClaimError))]) : _c('p', {
    staticClass: "vault-modal-text"
  }, [_vm._v(" This will submit your request and notify our team for processing. ")]), _c('div', {
    staticClass: "vault-modal-actions"
  }, [_c('button', {
    staticClass: "reward-cta",
    attrs: {
      "type": "button",
      "disabled": _vm.digitalClaimLoading
    },
    on: {
      "click": _vm.closeDigitalClaim
    }
  }, [_vm._v(" Cancel ")]), _c('button', {
    staticClass: "reward-cta",
    attrs: {
      "type": "button",
      "disabled": _vm.digitalClaimLoading
    },
    on: {
      "click": _vm.confirmDigitalClaim
    }
  }, [_vm._v(" " + _vm._s(_vm.digitalClaimLoading ? "Please wait..." : "Confirm") + " ")])])])]) : _vm._e()]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "vault-state-icon vault-state-icon--error",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('i', {
    staticClass: "fas fa-exclamation-circle"
  })]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "vault-state-icon vault-state-icon--empty",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('i', {
    staticClass: "fas fa-gift"
  })]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "reward-ribben"
  }, [_c('span', [_vm._v("—")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "flex flex-col"
  }, [_c('div', {
    staticClass: "reward-name"
  }, [_c('span', [_vm._v("No rewards in this vault")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('strong', [_c('i', {
    staticClass: "fas fa-star"
  }), _c('span', [_vm._v("Claimed")]), _c('i', {
    staticClass: "fas fa-star"
  })]);
}]

export { render, staticRenderFns }